export default "__VITE_ASSET__DOl88oWH__"